import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthService } from "../../services/authService";
import { Toast } from "../Toast/Toast";

export default function AuthWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const [status, setStatus] = useState<
    "loading" | "authorized" | "unauthorized"
  >("loading");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    // If not on /auth path, allow direct access (for development or already authenticated)
    if (!location.pathname.startsWith("/auth/")) {
      setStatus("authorized");
      return;
    }

    // On /auth path - process authentication immediately (no loader, Aviator has its own)
    // Parse auth from URL
    const result = AuthService.initializeFromUrl(
      location.pathname,
      location.search
    );

    if (!result.success) {
      setErrorMessage(result.error || "Authentication failed");
      setShowToast(true);
      setStatus("unauthorized");
      return;
    }

    // Store credentials immediately
    if (result.token) {
      AuthService.setToken(result.token);
    }
    if (result.eventId) {
      AuthService.setEventId(result.eventId);
    }
    if (result.currency) {
      AuthService.setCurrency(result.currency);
    }

    setStatus("authorized");

  }, [location.pathname, location.search]);

  // No loading state - just show children immediately (Aviator has its own loader)
  if (status === "loading") {
    return null;
  }

  if (status === "unauthorized") {
    return (
      <>
        {showToast && (
          <Toast
            message={errorMessage}
            type="error"
            duration={0}
            onClose={() => setShowToast(false)}
          />
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            color: "#ff4444",
            textAlign: "center",
            padding: "20px",
            background: "linear-gradient(135deg, #0d0d0d 0%, #1a1a2e 50%, #0d0d0d 100%)",
          }}
        >
          <h1 style={{ fontSize: "48px", marginBottom: "20px" }}>🔒</h1>
          <h2 style={{ fontSize: "24px", marginBottom: "10px" }}>
            Authentication Required
          </h2>
          <p style={{ fontSize: "16px", color: "#666", maxWidth: "500px" }}>
            {errorMessage ||
              "Please use a valid authentication URL to access this game."}
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      {showToast && (
        <Toast
          message={errorMessage}
          type="error"
          duration={5000}
          onClose={() => setShowToast(false)}
        />
      )}
      {children}
    </>
  );
}
